import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Polygon, Path, G } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function DotIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;


  return (

    <Svg
      {...svgProps}
      viewBox="0 0 48 48">
      <path d="M24 33C28.9706 33 33 28.9706 33 24C33 19.0294 28.9706 15 24 15C19.0294 15 15 19.0294 15 24C15 28.9706 19.0294 33 24 33Z" fill="#00a3e0" stroke="#00a3e0" stroke-width="4" />
    </Svg>

  );
}


DotIcon.defaultProps = {
  height: 20,
  width: 20,
};

DotIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

export default pure(DotIcon);
